export default __webpack_public_path__ + "static/anastasiaKitten-39599a40af427234f0da7578cad27997.webp";